var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1756383125032,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 36532,
    width: 18,
    height: 18,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M925.728 512l0 73.152q0 30.272-18.56 51.712t-48.288 21.44l-402.272 0 167.424 168q21.728 20.576 21.728 51.424t-21.728 51.424l-42.848 43.424q-21.152 21.152-51.424 21.152-29.728 0-52-21.152l-372-372.576q-21.152-21.152-21.152-51.424 0-29.728 21.152-52l372-371.424q21.728-21.728 52-21.728 29.728 0 51.424 21.728l42.848 42.272q21.728 21.728 21.728 52t-21.728 52l-167.424 167.424 402.272 0q29.728 0 48.288 21.44t18.56 51.712z",
    "p-id": 36533,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyArrowLeft);
export default __webpack_public_path__ + "static/media/my-arrow-left.82c26d89.svg";
export { ForwardRef as ReactComponent };